import React, { useState, useEffect } from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import GridContainer from 'components/Grid/GridContainer';
import { DataGrid, esES } from '@material-ui/data-grid';
import GridItem from 'components/Grid/GridItem';
import { wsFindBy } from 'services/WService';

const columns = [
  { field: 'CheckNum', headerName: 'Número', width: 120 },
  { field: 'CardName', headerName: 'Socio', width: 300 },
  { field: 'Currency', headerName: 'Moneda', width: 100, sortable: false, },
  { field: 'CheckSum', headerName: 'Monto', width: 200 },
  { field: 'CheckDate', headerName: 'Fecha de creación', width: 200 },
  { field: 'Deposited', headerName: 'Depositado', width: 200 },
];

function NewDepositChecks(props) {
  const { isDisabled, deposit, setDeposit, depositChecks, setDepositChecks } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [checks, setChecks] = useState([]);

  useEffect(() => {
    if (isDisabled) return;
    if (deposit.BanckAcct?.length !== 8) {
      setChecks([]);
      return;
    }

    setChecks([]);
    setIsLoading(true);
    wsFindBy('pymt/deposit/checks', { BanckAcct: deposit.BanckAcct })
      .then((res) => {
        if (!res.success) {
          alert('Error a listar los cheques');
          setIsLoading(false);
          return;
        }
        setChecks(res.data);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  }, [deposit.BanckAcct]);

  useEffect(() => {
    if (isDisabled) return;
    let validChecks = checks.filter((item) => depositChecks.includes(item.CheckKey));
    let LocTotal = validChecks.reduce(
      (previus, current) => previus + parseFloat(current.CheckSum),
      0,
    );
    setDeposit((deposit) => ({ ...deposit, LocTotal }));
  }, [depositChecks]);

  useEffect(() => {
    if (!isDisabled) return;
    setChecks(depositChecks);
  }, [depositChecks]);

  return (
    <CardContainer icon={null}>
      <GridContainer>
        {deposit.BanckAcct?.length === 8 ? (
          <GridItem xs={12}>
            <h4>{!isDisabled ? 'Seleccionar cheques' : `Cheques usados`}</h4>
          </GridItem>
        ) : (
          <GridItem xs={12}>
            <h4>Seleccione una cuenta de banco destino para listar los cheques disponibles</h4>
          </GridItem>
        )}

        {deposit.BanckAcct?.length === 8 && (
          <GridItem xs={12} style={{ height: '500px' }}>
            <DataGrid
              selectionModel={depositChecks}
              onSelectionModelChange={(model) => {
                if(isDisabled) return;
                setDepositChecks(model);
              }}
              localeText={esES.props.MuiDataGrid.localeText}
              columns={columns}
              getRowId={(row) => row.CheckKey}
              rows={checks}
              checkboxSelection={!isDisabled}
              loading={isLoading}
              disableColumnFilter
              disableColumnMenu
              disableColumnReorder
            />
          </GridItem>
        )}
      </GridContainer>
    </CardContainer>
  );
}

export default NewDepositChecks;
